import React from "react";
import { CheckSupplier } from "../../components";

const Check = () => {
  return <CheckSupplier />;
};

export default Check;
